import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { getCall } from './api-calls/apicalls.service';
import { HeadersService } from './api-calls/headers.service';

@Injectable({
    providedIn: 'root',
})
export class NoteService extends HeadersService {
    constructor(public _http: HttpClient) {
        super(_http);
    }

    postNote(
        dealId: string,
        title: string,
        content: string,
        internal: boolean
    ) {
        const url = getCall('note', null, {
            access: localStorage.getItem('user-access'),
        });

        const data = {
            deal: dealId,
            title: title,
            content: content,
            internal: internal,
        };

        return this._http.post(url, data, this.getHeaders());
    }

    updateNote(
        noteId: string,
        dealId: string,
        title: string,
        content: string,
        internal: boolean
    ) {
        const url = getCall('note', noteId, {
            access: localStorage.getItem('user-access'),
        });
        const data = {
            deal: dealId,
            title: title,
            content: content,
            internal: internal,
        };
        return this._http.put(url, data, this.getHeaders());
    }

    deleteNote(noteId: string, dealId: string) {
        const url = getCall('note', noteId, {
            access: localStorage.getItem('user-access'),
            deal: dealId,
        });
        return this._http.delete(url, this.getHeaders());
    }
}
